// extracted by mini-css-extract-plugin
export default {"infoText":"ProjectWorkstreamSelector-module__infoText___LCNKZ","title":"ProjectWorkstreamSelector-module__title___fbP1x"};